'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('payment-plan-edit', {
      url: '/user/payment-plan/edit/:id',
      template: '<payment-plan-edit></payment-plan-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/payment/plan-edit/payment-plan-edit.routes.js